import { usePermissionQueryActions } from '@/api/hooks/permissionQueryActions';
import type { ApiPermission } from '@/api/schema/data-contracts';

export const useHasGlobalPermission = (permission: ApiPermission) => {
  const { useGetPermissions } = usePermissionQueryActions();
  const { data } = useGetPermissions();

  if (!data) {
    return undefined;
  }

  return data.includes(permission);
};
